import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { MANDANTS } from '../../../../../store/utils/files-names';

export const getActiveMandantIdSelector = (
  state: AppRootState
): number | null => get(state, MANDANTS).activeMandantId;
